export default __webpack_public_path__ + "static/about-studio-acc569702d88a30e65bd7233a9bd73c1.png";